<script lang="ts">
	import Typeahead from 'svelte-typeahead';
	import * as m from '$lib/paraglide/messages';
	import type { SearchEntry } from '$lib/services/products';
	import { goto } from '$app/navigation';
	import { getSeedsContext } from '$lib/context';

	let { onSelect }: { onSelect?: (seed: SearchEntry) => void } = $props();

	const seedsOf = getSeedsContext();
	const seeds = $derived(seedsOf());

	const extract = (seed: SearchEntry) => {
		return seed.title;
	};

	const handleSelect = (
		e: CustomEvent<{
			searched: string;
			selected: SearchEntry;
			selectedIndex: number;
			original: SearchEntry;
			originalIndex: number;
		}>
	) => {
		goto(`${e.detail.original.slug}`);
		onSelect?.(e.detail.original);
	};
</script>

<!--
	The magnifier is positioned over the field rather than inside it: the input is
	rendered by `svelte-typeahead` and cannot be wrapped. Its left padding is set
	in `app.css` to leave room for this.

	`onSelect` fires after the navigation, which is what the mobile menu uses to
	close itself — otherwise the panel stays open over the page it just opened.
-->
<div class="relative">
	<svg
		class="pointer-events-none absolute top-1/2 left-4 z-10 h-4 w-4 -translate-y-1/2 text-muted"
		viewBox="0 0 20 20"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		aria-hidden="true"
	>
		<circle cx="9" cy="9" r="6" />
		<path stroke-linecap="round" d="m13.5 13.5 3.5 3.5" />
	</svg>

	<Typeahead
		hideLabel
		data={seeds}
		{extract}
		let:result
		on:select={handleSelect}
		placeholder={m.search()}
	>
		<div class="flex items-center gap-2">
			<!--
				`sizes` matters here more than anywhere: this is a 40px avatar, and
				without it the browser assumes the image fills the viewport and takes
				the widest source in the set — the full product photograph, for a
				thumbnail the size of a fingernail, once per result.
			-->
			<enhanced:img
				src={result.original.images[0]}
				alt={result.original.title}
				sizes="40px"
				class="h-10 w-10 rounded-full"
			/>
			<div>
				<h3>{result.original.title}</h3>
			</div>
		</div>
	</Typeahead>
</div>
